import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';

import './ConfigurationButton.scss';

export const ConfigurationButton = (props: { onClick: () => void }) => {
  return (
    <div className="configuration-button" onClick={props.onClick}>
      <FontAwesomeIcon icon={regular('ellipsis-h')} size="lg" fixedWidth />
    </div>
  );
};
